<template>
    <router-view class="main-wrap"></router-view>
</template>

<script>
import Footers from '@/template/Footer'
export default {
    name: 'App',
    components: {
        Footers
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue